export default {
    topics: [
        {
            title: ' FTP (Class) ',
            href: 'c-FTP.html',
            attributes: { 'data-id': 'c-FTP' },
            menu: { hasChildren: false },
            tocID: 'c-FTP-d66e5297',
            next: 'c-FTP-d66e5297',
        },
        {
            title: ' HttpClientRequest (Class) ',
            href: 'c-HttpClientRequest.html',
            attributes: { 'data-id': 'c-HttpClientRequest' },
            menu: { hasChildren: false },
            tocID: 'c-HttpClientRequest-d66e5353',
            next: 'c-HttpClientRequest-d66e5353',
        },
        {
            title: ' HttpClientResponse (Class) ',
            href: 'c-HttpClientResponse.html',
            attributes: { 'data-id': 'c-HttpClientResponse' },
            menu: { hasChildren: false },
            tocID: 'c-HttpClientResponse-d66e5450',
            next: 'c-HttpClientResponse-d66e5450',
        },
        {
            title: ' HttpSoapConnection (Class) ',
            href: 'c-HttpSoapConnection.html',
            attributes: { 'data-id': 'c-HttpSoapConnection' },
            menu: { hasChildren: false },
            tocID: 'c-HttpSoapConnection-d66e5506',
            next: 'c-HttpSoapConnection-d66e5506',
        },
        {
            title: ' SoapService (Class) ',
            href: 'c-SoapService.html',
            attributes: { 'data-id': 'c-SoapService' },
            menu: { hasChildren: false },
            tocID: 'c-SoapService-d66e5546',
            next: 'c-SoapService-d66e5546',
        },
    ],
};

